import { NgModule } from '@angular/core';
import { FirmPrefixPipe } from './firm-prefix.pipe';


@NgModule({
  declarations: [FirmPrefixPipe],
  exports: [FirmPrefixPipe],
})
export class FirmPrefixPipeModule {}
